import React, { useState } from 'react';
import PropTypes from 'prop-types';

import '@static/css/zrs/zrs-messages.less';

/**
 * ["ZipRecruiter Styles" (ZRS)](https://www-fedocs-01.legacy-dev-uw2.zipaws.com/fedocs/zrs) message.
 *
 * @see https://www-fedocs-01.legacy-dev-uw2.zipaws.com/fedocs/zrs#zrs.messages
 */
export function Message({ children, className, dismissable, hasIcon, type, ...props }) {
  const [isHiding, setIsHiding] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  const classNames = `Message zrs_message_${type}
    ${dismissable ? '' : 'not_dismissable'}
    ${hasIcon ? 'has_icon' : ''}
    ${isHiding ? 'delay-hiding' : ''}
    ${className}
  `;

  const onClose = () => {
    setIsHiding(true);
    setTimeout(() => {
      setIsHiding(false);
      setIsHidden(true);
    }, 500);
  };

  if (isHidden) { return null; }

  return (
    <div className={classNames} {...props}>
      <div>{children}</div>
      {dismissable && <button type="button" className="close_message" onClick={onClose}>Close</button>}
    </div>
  );
}

Message.propTypes = {
  /**
   * Flow content for a HTML paragraph element.
   *
   * https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories#Flow_content
   */
  children: PropTypes.node.isRequired,

  /** Additional CSS classes of the component. */
  className: PropTypes.string,

  /** Renders a close button if the message can be dismissed. */
  dismissable: PropTypes.bool,

  /** Renders an icon next to the message text. */
  hasIcon: PropTypes.bool,

  /**
   * Message type.
   *
   * From https://www-fedocs-01.legacy-dev-uw2.zipaws.com/fedocs/zrs#zrs.messages
   */
  type: PropTypes.oneOf(['info', 'alert', 'danger', 'success']),
};

Message.defaultProps = {
  className: '',
  dismissable: false,
  hasIcon: false,

  // default if attribute is not specified, like HTML buttons
  type: 'info',
};

export default Message;
